import { render, staticRenderFns } from "./Approve.vue?vue&type=template&id=7ec10142&scoped=true"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"
import style0 from "./Approve.vue?vue&type=style&index=0&id=7ec10142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec10142",
  null
  
)

export default component.exports